import { BgStatus } from 'Pages/ibro'

export const STATUS_WITH_ALLOWED_SEND = [
	BgStatus.NOVA,
	BgStatus.CL_CHECKED,
	BgStatus.FILLING,
	BgStatus.REWORK,
]

export const PRE_REQUEST_STATUS = [BgStatus.NOVA, BgStatus.CL_REJECTED]

export const STATUS_WITH_SAVE = [BgStatus.NOVA, BgStatus.CL_CHECKED]

export const STATUS_WITH_EDIT = [
	BgStatus.CL_CHECKED,
	BgStatus.POST_REQUEST_ERROR,
	BgStatus.CONSENT,
	BgStatus.CREATED,
	BgStatus.FILLING,
	BgStatus.REWORK,
	BgStatus.AST_CHECKING,
	BgStatus.DELETED,
	BgStatus.REJECTED,
	BgStatus.APPROVAL_TEXT,
	BgStatus.SENT_BANK,
	BgStatus.SENDING,
	BgStatus.PAY_WAITING,
	BgStatus.CHECKING,
	BgStatus.ONLINE_CHECKING,
]
export const STATUS_WITH_SEND = [BgStatus.NOVA, ...STATUS_WITH_EDIT]
export const STATUS_WITH_NAV = [BgStatus.RELEASED, BgStatus.CLOSED, ...STATUS_WITH_EDIT]
export const STATUS_WITH_DELIVERY_CORR = [
	BgStatus.RELEASED,
	BgStatus.SENDING,
	BgStatus.AST_CHECKING,
	BgStatus.ONLINE_CHECKING,
	BgStatus.CHECKING,
	BgStatus.APPROVAL_TEXT,
	BgStatus.PAY_WAITING,
	BgStatus.SENT_BANK,
]

export const STATUS_UNPAID_VIEW = [BgStatus.CHECKING, BgStatus.PAY_WAITING]

export const COMMENT_STATUS_DANGER = [BgStatus.POST_REQUEST_ERROR, BgStatus.REJECTED]

export enum StatusGartext {
	INCONSISTENT = -1,
	WITHOUT_AGREEMENT = 0,
	CONSIDERATION = 1,
	AGREED = 2,
}

export const STATUS_WITH_LEAD = [BgStatus.FILLING, BgStatus.REWORK, BgStatus.CL_CHECKED]
